import { useAuth } from "context/AuthProvider";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col, Form,
  FormGroup,
  Input, Label,
  Modal,
  Row, UncontrolledAlert
} from "reactstrap";
import { apiHorariosService } from "services/apiHorariosService";
import Jornadas from "./Jornadas";
import { showAppAlert } from "components/common/AppAlerts";

const AddHorario = (props) => {
  const { empresa } = useAuth();
  const navigate = useNavigate();
  const [nombre, setNombre] = useState(props.horario?.titulo || "");
  const [jornadas, setJornadas] = useState(
    props.horario?.jornadas || [{ diaSem: "", horaEntrada: "", horaSalida: "" }]
  );
  const [status, setStatus] = useState("pending");

  //Tratamiento de jornadas
  const [deleteIndex, setDeleteIndex] = useState([]);
  
  const addJornada = (diaSem) => {
    setJornadas([...jornadas, { diaSem: diaSem, horaEntrada: "", horaSalida: "" }]);
  };

  const copiarJornada = (copiaJornadas) => {
    setJornadas([...jornadas, ...copiaJornadas]);
  };


  const removeJornada = async (index) => {
    const updatedJornadas = [...jornadas];
    updatedJornadas.splice(index, 1);

    setDeleteIndex([...deleteIndex, index]);
    // Pausa de 1 segundo
    await new Promise((resolve) => setTimeout(resolve, 300));
    setJornadas(updatedJornadas);
    setDeleteIndex([]);
  };
  const handleJornadaChange = (index, fieldName, value) => {
    const updatedJornadas = [...jornadas];
    updatedJornadas[index][fieldName] = value;
    setJornadas(updatedJornadas);
  };

  //fin tratamiento de jorandas

  const handleChange = (e) => {
    setNombre(e.target.value);
  };

  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const handleClear = (e) => {
    e.preventDefault();
    setNombre("");
    setJornadas([{ diaSem: "", horaEntrada: "", horaSalida: "" }]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const json = {
      titulo: nombre,
      empresa: { id: empresa.id },
      jornadas: jornadas.filter(j => j.diaSem != ""),
    };

    if (props.horario?.id) {
      const response = await apiHorariosService.update(
        empresa.id,
        props.horario.id,
        json
      );
      setStatus(response.status);
    } else {
      const response = await apiHorariosService.create(json);
      setStatus(response.status);
      if (response.status === "saved") {
        handleClear(e);
      }
    }

    // Limpiar el estado después de 3 segundos
    setTimeout(() => {
      setStatus("pending");
    }, 3000);
  };

  const handleDelete = async (e) => {
    e.preventDefault();

    const response = await apiHorariosService.deleteById(props.horario.id);
    if (response.message === "saved") {
      showAppAlert("Se ha eliminado correctamente", "success");
      navigate("/admin/horarios");
    } else {
      showAppAlert("No se ha podido eliminar, hay elementos enlazados.", "error");
    }
  };

  const lg = 12;
  return (
    <>
      <Card>
        <CardHeader>Dar de alta horario:</CardHeader>
        <CardBody>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col lg={lg}>
                <FormGroup>
                  <Label htmlFor="nombre" className="form-control-label">
                    Nombre:
                  </Label>
                  <Input
                    type="text"
                    name="nombre"
                    className="form-control-alternative"
                    value={nombre}
                    onChange={handleChange}
                    required
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col>
                <h3> Jornadas: </h3>
              </Col>
            
            </Row>

{/* Aquí va la selección de jornadas*/ }
            <Jornadas jornadas={jornadas} addJornada={addJornada} handleJornadaChange={handleJornadaChange} removeJornada={removeJornada} copiarJornada={copiarJornada}></Jornadas>

            <div className="text-right mt-3">
              <Button className="btn btn-success" type="submit">
                Guardar
              </Button>
              {props.horario?.id && (
                <Button className="btn btn-danger" onClick={toggleModal}>
                  Eliminar
                </Button>
              )}
              <Button
                className="btn btn-secondary"
                onClick={() => navigate("/admin/horarios")}
              >
                Volver
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
      <div className="mt-3">
        {status === "saved" ? (
          <UncontrolledAlert color="success" fade={true}>
            <span className="alert-inner--icon">
              <i className="ni ni-like-2" />
            </span>{" "}
            <span className="alert-inner--text">
              <strong>¡Guardado!</strong> Se ha guardado correctamente
            </span>
          </UncontrolledAlert>
        ) : (
          ""
        )}
        {status === "duplicated" ? (
          <UncontrolledAlert color="warning" fade={true}>
            <span className="alert-inner--icon">
              <i className="ni ni-fat-remove" />
            </span>{" "}
            <span className="alert-inner--text">
              <strong>¡Duplicado!</strong> Este horario ya existe.
            </span>
          </UncontrolledAlert>
        ) : (
          ""
        )}

        {status === "error" ? (
          <UncontrolledAlert color="danger" fade={true}>
            <span className="alert-inner--icon">
              <i className="ni ni-fat-remove" />
            </span>{" "}
            <span className="alert-inner--text">
              <strong>¡Error!</strong> Se ha producido un error.
            </span>
          </UncontrolledAlert>
        ) : (
          ""
        )}
      </div>

      <Modal className="modal-dialog-centered" isOpen={modalOpen}>
        <div className="modal-header">
          <h2 className="modal-title" id="exampleModalLabel">
            ¿Está seguro que quiere eliminarlo?
          </h2>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => toggleModal()}
          >
            <span aria-hidden={true}>x</span>
          </button>
        </div>
        <div className="modal-body text-right">
          <Button color="danger" onClick={handleDelete}>
            Sí
          </Button>
          <Button color="secondary" onClick={() => toggleModal()}>
            No
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default AddHorario;


